import React from 'react';
import { Moment } from 'moment';
import { Modifier as CalendarModifier } from '@erecruit/ui-kit/src/molecules/Calendar/Calendar';

export interface AddNewShiftWizardFields {
  departmentId?: number;
  shiftTypeId?: number;
  startTime?: Moment;
  endTime?: Moment;
  selectedDates: Record<string, CalendarModifier>;
  selectedDatesQuantities: Record<string, number>;
  selectionPerType: Record<string, string[]>;
}

export const WizardContext = React.createContext<AddNewShiftWizardFields>({
  selectedDates: {},
  selectedDatesQuantities: {},
  selectionPerType: { multiple: [], range: [], single: [] },
});
